export default "__VITE_ASSET__wWwINuZe__"